
	import ModeloCadastro from '@/views/paginas/sigap/modelos/ModeloCadastro.vue';   
    import { Options   } from "vue-class-component";   
    import {  Qts } from "./Qts"; 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import QtsPdfService from   "@/service/v1/sigap/QtsPdfService"   
	import $ from "jquery"   
    import { ref } from 'vue';
	  
    @Options({
        name: "QtsCadastro",
        components: {   },  
        emits: [  'qts-alterado'],  
    }) 
    export default class QtsCadastro extends ModeloCadastro {
        
        public service = new QtsPdfService(); 

        private arquivoReferencia = ref<FileList | null>(null);
        public arquivo: any = '';
        public turmaId: any = null;

         
        handleFileUpload() {  
            this.arquivo =  ( this.arquivoReferencia as any ).files![0]; 
        }
  
        async created()  {  
            this.titulo = 'Cadastrar Qts';
            this.campos =  Qts.campos(); 
            this.turmaId = this.$route.params.id;
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE] ,  this.perfis); 
        }
    
        public sucesso(){  
            this.$emit("qts-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        
        public getdados(){   
            let dados = JSON.parse(JSON.stringify(this.formulario));  
            dados.TurmaId = this.$route.params.id; 
            return dados;
        }

        public salvar() {  
            this.processando = true;
            const dados = new FormData(); 
            if (this.arquivo && this.formulario.nome && this.formulario.inicio && this.formulario.fim) {
                dados.append('File', this.arquivo);
                dados.append('nome', this.formulario.nome);
                dados.append('inicio', this.formulario.inicio);
                dados.append('fim', this.formulario.fim); 
                dados.append('TurmaId', this.turmaId);
            } 
            this.service.cadastrarArquivo( dados )
            .then(response => {
                this.sucesso(); 
                SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                this.processando = false; 
            })
            .catch(error => {  
                this.processando = false; 
                console.log(error);
            })
            .finally( () => {
                this.processando = false;
            });    
        } 
 

        // public salvar2(){
        //     if( this.processando  ||  !this.hasPermissao ){
        //         return;
        //     }
        //     this.processando = true ;  
        //     let dados = this.getdados() ;  
        //     setTimeout(() => {  
        //         this.service.cadastrar(   dados )
        //         .then(response => { 
        //             SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
        //             this.sucesso();   
        //             this.processando = false ; 
        //             this.editando = false ;
        //         }) 
        //         .catch(error => {
        //             this.processando = false ;
        //             SiteUtils.toastErro('Error! ' ,  error.data.message  );
        //         });  
        //     }, 100); 
        // }  

    } 
